import { useMemo } from "react";
import _ from "lodash";
import { isCmsRole } from "../../functions/permissions";
import { useAllUsers } from "./useUsers";

/**
 * Alle accounts met CMS-toegang. Dat zijn twee soorten: accounts die via een
 * uitnodiging zijn aangemaakt (`role`) en webshopaccounts die daarnaast
 * CMS-toegang hebben gekregen (`cmsRole`, hun `role` blijft "webshopUser").
 * Gebruik deze hook waar je "collega's" nodig hebt — taaktoewijzing, auteur van
 * een notitie, de gebruikerslijst in Beheer.
 *
 * Tot BMX-56 waren dit twee eigen Firestore-queries in App.js (`cmsUsers` en
 * `cmsLinkedUsers`). Die stonden op dezelfde collectie als de klantenlijst en
 * lieten Firestore die grootste query per document uitleveren — zie
 * data/hooks/useUsers.js voor wat dat kostte. Nu afgeleid uit die ene lijst.
 */
export const useCmsUsers = () => {
  const users = useAllUsers();
  return useMemo(() => {
    if (!Array.isArray(users)) return [];
    // Twee velden, want Firestore kon er niet over OR-en; in het geheugen kan
    // het in één doorloop, maar unionBy blijft staan voor de contractgelijkheid
    // (accounts met zowel `role` als `cmsRole` komen één keer terug).
    return _.unionBy(
      users.filter((user) => isCmsRole(user?.role)),
      users.filter((user) => isCmsRole(user?.cmsRole)),
      "id",
    );
  }, [users]);
};

export default useCmsUsers;
